var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"approval-type__icon"},[_c('Icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }